export const initialStateCliente = {
   cuit: null,
   nombre: null,
   apellido: null,
   razonSocial: null,
   domicilio: null,
   codigo_postal: null,
   id_condicion_fiscal: null,
   id_cliente: null,
   email: null,
   localidad: null,
   id_localidad: null,
   telefono: null,
   tipo_persona: null,
   sexo: null,
   fechaNacimiento: null,
   actividad: null,
   ingresosBrutos: null,
   iibb: null,
};
export const initialStateReferente = {
   cuit: null,
   nombre: null,
   telefono: null,
   email: null,
   observaciones: null,
};

export function getInitialStateClient() {
   return {
      cliente: { ...initialStateCliente },
      referente: { ...initialStateReferente },
      tipoDocumento: [
         { label: 'CUIT/CUIL', value: 'cuit' },
         // { label: 'DNI', value: 'dni' },
      ],
   };
}

export default getInitialStateClient();
